import Moment from 'moment';


export const allChannels = [
    { code: '100', name: '保密职位' },
    { code: '200', name: '内部推荐' },
    { code: '300', name: '猎头推荐' },
    { code: '400', name: '活水计划' },
    { code: '600', name: '自招职位' },
    { code: '501', name: '滴滴门户' },
    { code: '502', name: '前程无忧', label: 'Qcwy', icon: 'qcwy' },
    { code: '503', name: '智联招聘', label: 'Zlzp', icon: 'zlzp' },
    { code: '504', name: '猎聘', label: 'Lp', icon: 'lp' },
    { code: '505', name: '拉勾', label: 'Lg', icon: 'lg' },
];

export const hrDataMap = {
    dimission: '离职原因',
    dimissionRemark: '离职原因备注',
    jobWanted: '求职原因',
    jobWantedRemark: '求职原因备注',
    careerPlanning: '职业规划',
    jobExpect: '岗位期望',
    recommend: '推荐理由',
    paymentExpect: '薪酬现状和期望',
    supplementRemark: '简历补充/修正/存疑信息',
};

export const passStatus = {
    0: {
        title: '面试已安排',
        color: '#fc9153',
    },
    1: {
        title: '面试待定',
        color: '#1890ff',
    },
    2: {
        title: '面试通过',
        color: '#21c480',
    },
    3: {
        title: '面试淘汰',
        color: '#ff5656',
    },
    4: {
        title: '面试优秀',
        color: '#21c480',
    },
    5: {
        title: '面试极好',
        color: '#21c480',
    },
};

export const questionText = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
    10: '十',
    11: '十一',
    12: '十二',
    13: '十三',
    14: '十四',
    15: '十五',
    16: '十六',
    17: '十七',
    18: '十八',
    19: '十九',
    20: '二十',
};

export const countryCode = [
    { key: '86', name: '中国大陆(86)' },
    { key: '852', name: '中国香港(852)' },
    { key: '853', name: '中国澳门(853)' },
    { key: '886', name: '中国台湾(886)' },
    { key: '61', name: '澳大利亚(61)' },
    { key: '55', name: '巴西(55)' },
    { key: '7', name: '俄罗斯(7)' },
    { key: '82', name: '韩国(82)' },
    { key: '1', name: '美国(1)' },
    { key: '1', name: '加拿大(1)' },
    { key: '81', name: '日本(81)' },
    { key: '65', name: '新加坡(65)' },
    { key: '44', name: '英国(44)' },
];

export const levelList = [
    { key: 'D4', name: 'D4' },
    { key: 'D5', name: 'D5' },
    { key: 'D6', name: 'D6' },
    { key: 'D7', name: 'D7' },
    { key: 'D8', name: 'D8' },
    { key: 'D9', name: 'D9' },
    { key: 'D10', name: 'D10' },
    { key: 'D11', name: 'D11' },
    { key: 'D12', name: 'D12' },
    { key: 'M1', name: 'M1' },
    { key: 'M2', name: 'M2' },
    { key: 'M3', name: 'M3' },
    { key: 'M4', name: 'M4' },
    { key: 'M5', name: 'M5' },
    { key: 'M6', name: 'M6' },
    { key: 'M7', name: 'M7' },
    { key: 'M8', name: 'M8' },
    { key: 'M9', name: 'M9' },
    { key: 'M10', name: 'M10' },
    { key: 'M11', name: 'M11' },
    // { key: 'M12', name: 'M12' },
];

export const nonCadres = ['D4','D5','D6','D7','D8','D9','M1','M2','M3']

export const levelSuffixList = [
    { key: '+', name: '+' },
    { key: '-', name: '-' },
];

export const phoneRegexCN = /^1[3-9]\d{9}$/;
export const phoneRegexOther = /^[0-9]+$/;
export const emailRegex =/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
export const weekOutReasonList = ['职位方向不匹配', '招聘需求调整', '工作经验不足'];
export const neiTuiList = [200, 201, 202, 203, 204];
export const hunterList = [300];
const basicPath = location.origin;
export const workbenchPath = {
    applicantPath: `${basicPath}/workbench/applicants`,
    resumePath: `${basicPath}/workbench/filter`,
    interviewFeedbackPath: `${basicPath}/workbench/interview`,
};
export const huoShuiList = [400];
export const hideStatusChange = [502, 505];

// 主要重置搜索的值
export const resetValue = (params, key, value) => {
    if (params[key]) {
        params[key] = value;
    } else if (params[key]) {
        delete params[key];
    }

    return params;
};

// 主要重置搜索的时间的值
export const resetTimeValue = (params, key, startTime, endTime, isNotNeedTime) => {
    if (params[key] && params[key].length) {
        if (!isNotNeedTime) {
            params[startTime] = Moment(params[key][0]).isValid() ? Moment(params[key][0]).format('YYYY-MM-DD') : '';
            params[endTime] = Moment(params[key][0]).isValid() ? Moment(params[key][1]).format('YYYY-MM-DD') : '';
            params[startTime] = params[startTime] ? `${params[startTime]} 00:00:00` : '';
            params[endTime] = params[endTime] ? `${params[endTime]} 23:59:59` : '';
        } else {
            params[startTime] = Moment(params[key][0]).isValid() ? Moment(params[key][0]).format('YYYY-MM-DD HH:mm:ss') : '';
            params[endTime] = Moment(params[key][0]).isValid() ? Moment(params[key][1]).format('YYYY-MM-DD HH:mm:ss') : '';
        }
    } else {
        if (params[startTime]) {
            delete params[startTime];
        }

        if (params[endTime]) {
            delete params[endTime];
        }
    }

    delete params[key];
    return params;
};

export const getObjList = (obj = {}, list = []) => {
    for (const objKey of Object.keys(obj)) {// eslint-disable-line
        const target = obj[objKey];
        // Object.assign(target, {key: `${target.key}`});
        list.push({ key: +objKey, value: target });
    }

    return list;
};

export const mirrorEvent = (ldap = '', category = 'default', action = 'default', value = '') => {
    let parameterObject = {}
    parameterObject.category = category
    parameterObject.action = action
    parameterObject.name = ldap
    parameterObject.dimension1 = value
    window.taotieCommandQueue.push({
      command: 'sendEventlogMessageToKafka',
      parameter: parameterObject
    })
  }
  